import data from './versions.json'
export const versions = data.versions;